import * as PropTypes from "prop-types"
import styled, { css } from "styled-components"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import { Check } from "components/icons/check"

const VisuallyHidden = css`
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  white-space: nowrap !important;
`

const Input = styled.input`
  ${VisuallyHidden};
`

const Label = styled(Typography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: 0;
  padding: 10px 5px 8px;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.weights.regular};
  line-height: 14px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  transition: color 0.2s, background-color 0.2s;
  cursor: pointer;

  /* display: -webkit-box;
  height: auto;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  */

  &:hover,
  ${Input}:focus ~ &,
  ${Input}:checked ~ & {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.deepPink};
  }
`

const OptionContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

const SelectedIcon = styled(Icon)`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 21px;
  height: 21px;
  padding: 4px 3px 3px;
  color: ${({ theme }) => theme.colors.deepPink};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  box-shadow: 0px 2px 6px 1px #0008;
  z-index: 1;
`

export default function Item({ label, value, onChange, selected }) {
  const id = value

  return (
    <OptionContainer>
      {selected && <SelectedIcon aria-hidden Icon={Check} />}
      <Input type="radio" id={id} name="job_type" onChange={() => onChange(value)} value={value} checked={selected} />
      <Label as="label" variant="body" htmlFor={id}>
        {label}
      </Label>
    </OptionContainer>
  )
}

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
}
